import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { IDatePeriod } from 'src/components/period-selector';

const PeriodDisplay = function ({ period }: { period?: IDatePeriod }) {
  const humanReadable = period
    ? `${period.dates.start.format('YYYY-MM-DD HH:mm')} - ${period.dates.end.format(
        'YYYY-MM-DD HH:mm',
      )}`
    : 'Ingen period vald';
  return (
    <Stack direction="column" spacing={0} justifyContent="center">
      <Typography variant="caption">Visar data för</Typography>
      <Typography variant="body2">{humanReadable}</Typography>
    </Stack>
  );
};

PeriodDisplay.defaultProps = {
  period: undefined,
};

export default PeriodDisplay;
